import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgTemperatureIconSecondary from './svgs/TemperatureIconSecondary.js';
import SvgTemperatureIcon from './svgs/TemperatureIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var temperatureIcon = (props => useIcon(SvgTemperatureIcon, SvgTemperatureIconSecondary, props));

export { temperatureIcon as default };
